<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('user.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('user.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-10">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'user-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <ts-table
          :columns="columns"
          :records="resources"
          :rowGroup="{
            field: 'user_type.label'
          }"
        >
          <template v-slot="{ record }">
            <td>{{ record.user_name }}</td>
            <td>
              <span
                class="badge badge-primary mr-2"
                v-for="(role, index) in record.roles"
                >{{ role.name == '*' ? 'Everything' : role.name }}</span
              >
            </td>
            <td class="text-center">
              <a
                href="#"
                class="mr-2 text-info"
                @click.prevent="showModal(record)"
              >
                <i class="fa fa-lock"></i>
              </a>
              <a
                href="#"
                class="mr-2 text-primary"
                @click.prevent="onEdit(record)"
              >
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
        <a-modal
          v-model="visible_resetpwd"
          :title="$t('user.resetPassword')"
          @ok="handleOk"
          @cancel="closeModal"
          width="20%"
          :okText="$t('save')"
          :confirmLoading="waiting"
          :cancelText="$t('cancel')"
          :maskClosable="false"
        >
          <div class="row form-group">
            <div class="col-md-12">
              <label class="required ts-text-xs">{{
                $t('user.password')
              }}</label>
              <input
                v-model="model.new_password"
                type="password"
                class="form-control"
                :class="{ 'is-invalid': errors.has('new_password') }"
              />
              <div class="invalid-feedback" v-if="errors.has('new_password')">
                {{ errors.first('new_password') }}
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <label class="required ts-text-xs">{{
                $t('user.confirm')
              }}</label>
              <input
                v-model="model.confirm_password"
                type="password"
                class="form-control"
                :class="{ 'is-invalid': errors.has('confirm_password') }"
              />
              <div
                class="invalid-feedback"
                v-if="errors.has('confirm_password')"
              >
                {{ errors.first('confirm_password') }}
              </div>
            </div>
          </div>
        </a-modal>
      </ts-loading-banner>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'userIndex',
  data() {
    return {
      numeric: 1,
      visible_resetpwd: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      model: {
        user_id: 0,
        new_password: null,
        confirm_password: null
      }
    }
  },
  computed: {
    ...mapState('security/user', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.security.user.search
      },
      set(newValue) {
        this.$store.commit('security/user/SET_SEARCH', newValue)
        this.$store.commit('security/user/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('user.userName') },
        { name: this.$t('user.roleName') },
        { name: this.$t('actions'), style: 'width:7%; text-align:center' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('security/user/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onEdit(record) {
      this.$store.commit('security/user/SET_EDIT_DATA', record)
      this.$router.push({ name: 'user-edit', params: { id: record.user_id } })
    },
    showModal(record) {
      this.model.user_id = record.user_id
      this.visible_resetpwd = true
    },
    closeModal() {
      this.model.user_id = 0
      this.model.new_password = 0
      this.model.confirm_password = 0
      this.visible_resetpwd = false
      this.errors = new Errors()
    },
    handleOk() {
      this.waiting = true
      this.$store
        .dispatch('security/user/resetpwd', {
          id: this.model.user_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.closeModal()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
